var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_798_6174",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_798_6174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 6.99935C7.32075 6.99935 7.5954 6.88511 7.82388 6.65664C8.05235 6.42817 8.16658 6.15352 8.16658 5.83268C8.16658 5.51185 8.05235 5.2372 7.82388 5.00872C7.5954 4.78025 7.32075 4.66602 6.99992 4.66602C6.67909 4.66602 6.40443 4.78025 6.17596 5.00872C5.94749 5.2372 5.83325 5.51185 5.83325 5.83268C5.83325 6.15352 5.94749 6.42817 6.17596 6.65664C6.40443 6.88511 6.67909 6.99935 6.99992 6.99935ZM6.99992 12.8327C5.43464 11.5007 4.26554 10.2636 3.49263 9.12122C2.71971 7.97886 2.33325 6.92157 2.33325 5.94935C2.33325 4.49102 2.80235 3.32921 3.74054 2.46393C4.67874 1.59865 5.7652 1.16602 6.99992 1.16602C8.23464 1.16602 9.3211 1.59865 10.2593 2.46393C11.1975 3.32921 11.6666 4.49102 11.6666 5.94935C11.6666 6.92157 11.2801 7.97886 10.5072 9.12122C9.73429 10.2636 8.5652 11.5007 6.99992 12.8327Z",
    fill: "#7A868C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.1ee38cd8b0aa8b7d37a35d74296b5bc7.svg";
export { ForwardRef as ReactComponent };